import { add } from 'date-fns';

export function addMinutes(date, minutes) {
  return add(date, { minutes });
}

export function isToday(date) {
  const today = new Date();
  return date.toLocaleDateString() === today.toLocaleDateString();
}

export function roundToNextHalfHour(date) {
  const nextOffset = (date.getMinutes() < 30 ? 30 : 60);
  return add(new Date(), { minutes: nextOffset });
}

export function formatTimeOption(date) {
  const timeSlot = new Intl.DateTimeFormat('en-US', { timeStyle: 'short' }).format(date);
  return `${timeSlot} CST`;
}

export function defaultTimeSlots(startHour = 7, endHour = 18.5, slotSize = 0.5) {
  const slots = [];
  for (let time = startHour; time <= endHour; time += slotSize) {
    const hour = Math.floor(time);
    const minute = (time - hour) * 60;
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    slots.push(date);
  }
  return slots;
}

export function timeSlotsForDate(date) {
  const allTimeSlots = defaultTimeSlots();

  if (date && isToday(date)) {
    const dateWithLeadTime = add(new Date(), { minutes: 30 });
    const roundedCstDate = roundToNextHalfHour(dateWithLeadTime);
    const filteredTimeSlots = allTimeSlots.filter(
      (timeSlot) => timeSlot >= roundedCstDate,
    );
    const hasResults = allTimeSlots[0] > roundedCstDate || !filteredTimeSlots.length;
    return hasResults ? [] : filteredTimeSlots.map(formatTimeOption);
  }
  return allTimeSlots.map(formatTimeOption);
}

const DatePickerHelpers = {
  isToday,
  roundToNextHalfHour,
  formatTimeOption,
  defaultTimeSlots,
  timeSlotsForDate,
};

export default DatePickerHelpers;
